import { Dinero } from 'dinero.js';
import { capitalize } from 'lodash';
import { Typography } from '@dagensmat/carrot/Components';
import { Container } from '@dagensmat/carrot/Layout';
import { formatDate } from 'utils/date/format';
import { fmtMoney } from 'utils/texts';
import Separator from '_common/components/utils/Separator.style';

type CheckoutFooterDateLineProps = {
  deliveryDate: string;
  dayTotal: Dinero<number>;
};

const CheckoutFooterDateLine = ({
  deliveryDate,
  dayTotal
}: CheckoutFooterDateLineProps) => {
  return (
    <>
      <Container flex justify="space-between" alignItems="baseline" mb="xs">
        <Typography variant="paragraphSmall">
          {capitalize(formatDate(deliveryDate))}
        </Typography>
        <Typography variant="paragraphSmall">{fmtMoney(dayTotal)}</Typography>
      </Container>
      <Separator />
    </>
  );
};

export default CheckoutFooterDateLine;
